import React, { Suspense } from 'react';
import { Img } from 'react-image';
import Loader from '../../utils/Loader';

const LoadImage = (props) => {

  const {
    img,
    alt,
    title,
    classe,
    style
  } = props ;

  return (
    <Suspense>
      <Img 
        src={img}
        loader={<Loader size="50" />}
        className={classe}
        title={title}
        alt={alt}
        style={ style }
      />
    </Suspense>
  );
}

export default LoadImage;
